import { useSuspenseQuery } from "@tanstack/react-query";
import { STANDARD_QUERY_CACHE_CONFIG } from "@lending/lib/queryConfig";
import type { AccountOpeningProductsResponse } from "@lending/types";

function useGetAccountOpeningProductsQuery() {
  const query = useSuspenseQuery<AccountOpeningProductsResponse>({
    queryKey: ["accountOpeningProducts"],
    queryFn: async () => {
      const response = await fetch(`${import.meta.env.VITE_PUBLIC_API_URL}/v1/products/`);
      if (!response.ok) {
        throw new Error("Failed to fetch account opening products");
      }
      return response.json() as Promise<AccountOpeningProductsResponse>;
    },
    ...STANDARD_QUERY_CACHE_CONFIG,
  });

  return {
    products: query.data?.products,
    productCategoryLimits: query.data?.product_category_limits,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}

export { useGetAccountOpeningProductsQuery };
